<template>
  <div :class="{ 'hidden': hidden }" class="pagination-container">
    <el-pagination :background="background" :current-page.sync="currentPage" :pagerCount="pagerCount" :page-size.sync="pageSize" :layout="layout"
                   :page-sizes="pageSizes" :total="total" v-bind="$attrs" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange">
      <span class="pagination-slot">{{ $t('entorguser.findallpage') }} <div class="num">{{ total }}</div> {{ $t('entorguser.page2') }}&nbsp;&nbsp;{{ currentPage + '/' + pageTotal + $t('entorguser.page3') }}</span>
    </el-pagination>
  </div>
</template>

<script>
import {scrollTo} from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pagerCount: {
      type: Number,
      default: 5
    },
    pageSizes: {
      type: Array,
      default() {
        return [5,10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'slot, prev, pager, next,sizes, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageTotal() {
      return Math.ceil(this.total / this.pageSize)
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      if(this.page>Math.ceil(this.total / val)){
        this.$emit('update:page', Math.ceil(this.total / val))
      }
      this.$emit('pagination', {page: this.currentPage, limit: val})
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', {page: val, limit: this.pageSize})
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pagination-container {
  background: #fff;
  padding: 5px 0;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1665D8;
}

.pagination-slot {
  float: left;
  margin-left: 10px;
  font-weight: 500;
}

.pagination-container.hidden {
  display: none;
}

.num {
  display: inline-block;
  font-weight: bold;
}
</style>
